import React from 'react'
import CircleImage from "../Image/CircleImage";
import { Translate } from "react-redux-i18n"; 

const CircleMeta=({circle})=>{
    return (
        <div className="circle-meta">
            <div className="circle-image">
                <CircleImage size="small" src={circle.products[0].image_url} alt={circle.products[0].name} />
            </div>
            <div className="circle-details">
                <h1>{circle.products[0].name}</h1>
                <div className="circle-group">
                    {circle.max_owners_no+' '}   
                        <Translate value="circle_admin.members" />
                    , {circle.city}, {circle.country}
                </div>
            </div>
        </div>
    )
}
export default CircleMeta;